<template>
  <div class="info-window">
    <div class="header">拖动蓝色标注可调整药店位置</div>
    <div class="name">药店位置</div>
    <div class="address">{{ address }}</div>
    <div class="btn-wrap">
      <div class="btn save" @click="onSave">确定</div>
      <div class="btn cancel" @click="onCancel">取消</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['address'],
  methods: {
    onSave() {
      this.$emit('onSave');
    },
    onCancel() {
      this.$emit('onCancel');
    }
  }
};
</script>

<style lang="scss" scoped>
.info-window {
  position: relative;
  width: 208px;
  height: 122px;
  font-size: 12px;
  line-height: 18px;
  background-color: #fff;
  border-radius: 4px;
  padding: 0 12px;
  padding-top: 12px;
  box-shadow: 0px 4px 16px 0px rgba(32, 32, 32, 0.2), 0px 4px 12px 0px rgba(51, 51, 51, 0.2);
  .header {
    color: #bdbdbd;
    margin-bottom: 8px;
  }
  .name,
  .address {
    color: #333;
  }
  .btn-wrap {
    display: flex;
    justify-content: space-evenly;
    position: absolute;
    bottom: 12px;
    left: 0;
    right: 0;
    .btn {
      width: 80px;
      height: 24px;
      border-radius: 3px;
      border: 1px solid transparent;
      text-align: center;
      line-height: 24px;
      &.save {
        background: #1e8dff;
        color: #fff;
      }
      &.cancel {
        background-color: #fff;
        color: #1e8dff;
        border-color: #1e8dff;
      }
    }
  }
}
</style>
